import styles from "../styles/FilterItem.module.scss";
import React, { useState } from "react";

export default function FilterItem({
  name,
  choices,
  handleInputChange,
}: {
  name: string;
  choices: { [key: string]: boolean };
  handleInputChange: (event) => void;
}) {
  const [toggled, setToggled] = useState(true);

  function handleToggled() {
    setToggled(!toggled);
  }

  function getFilterItems() {
    const filterItems = [];

    for (const [key, value] of Object.entries(choices)) {
      filterItems.push(
        <div key={key}>
          <label>
            <input
              name={key}
              type="checkbox"
              checked={value}
              onChange={handleInputChange}
            />
            <span className={styles.checkmark}></span>
            {key}
          </label>
        </div>
      );
    }

    return filterItems;
  }

  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <p>Filter by {name}</p>
        <div
          className={`${styles.circle} ${toggled && styles.opened}`}
          onClick={handleToggled}
        >
          <div className={styles.horizontal}></div>
          <div className={styles.vertical}></div>
        </div>
      </div>
      <div className={`${styles.filter_items} ${toggled && styles.show}`}>
        {getFilterItems()}
      </div>
    </div>
  );
}
